import {
    updateField
} from 'vuex-map-fields';
import original_state from './state';
export default {
    updateLoginField(state, field) {
        updateField(state.login, field);
    },
    updateRegisterField(state, field) {
        updateField(state.register, field);
    },
    updateResetPasswordField(state, field) {
        updateField(state.reset_password, field);
    },

    // clear state
    clearAuthState(state, key) {
        state[key] = original_state()[key];
    },
}